export const getAtendendoComo = (id) => {
  switch (id) {
    case 1:
      return 'Delivery'
    case 2:
      return 'Retirada'
    case 3:
      return 'Delivery e Retirada'
    default:
      return ''
  }
}
